import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useQuery } from '@apollo/client';
import { Block, PageMetaData } from '@components/components';
import { CategoryBreadcrumbs } from '@components/components/CategoryBreadcrumbs/CategoryBreadcrumbs';
import { CJAffiliationTag } from '@components/components/CJAffiliation/CJAffiliationTag';
import { OnMobileAndTabletOnly } from '@components/layout-components';
import { ContentfulPagesRenderer } from '@components/renderers/ContentfulPagesRenderer';
import { Loader } from '@core-frontend/components';
import { avaliableBlocks } from '@core-utils/avaliableBlocks';
import { useRouter } from 'next/router';

import StateContainer from './StateContainer/StateContainer';
import { categoryPageQuery } from './CategoryPageQuery';

import EditorialPagesStyles from '../EditorialPage/EditorialPage.module.scss';

const mockedImage = '/images/mockedProduct.png';

export const getCfVars = query => {
  return {
    query: {
      fields: {
        slug: Array.isArray(query.uri) ? query.uri.join('/') : query.uri,
      },
    },
  };
};

export const CategoryPage = () => {
  const router = useRouter();
  const routeUri = Array.isArray(router.query.uri) ? router.query.uri.join('/') : null; // removing / from the end of the slug, to make it match the CF slug
  const variables = getCfVars(router.query);

  const { error, loading, data } = useQuery(categoryPageQuery, { variables, skip: !router.query.uri });

  if (!data) {
    return null;
  }

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <FormattedMessage id="error.sad" />
      </div>
    );
  }

  const categoryPageConfig = Array.isArray(data.cfPages) && data.cfPages[0];

  let gridConfigs;
  if (categoryPageConfig) {
    const { gridConfig, mobileGridConfig } = categoryPageConfig;
    const isMultigrid = gridConfig && mobileGridConfig;

    gridConfigs = isMultigrid && {
      gridConfig: gridConfig && gridConfig.config,
      mobileGridConfig: mobileGridConfig && mobileGridConfig.config,
    };
  }

  const {
    instagram,
    textintro,
    centraProducts,
    textbar,
    promo50,
    promo50small,
    spacer,
    featuredproduct,
    texteditor,
    hero,
    hero50,
    hero50textimage,
    panorama,
    panorama50,
    tripplepromo,
    tripplepromotext,
    textquote,
  } = avaliableBlocks;

  const params = {
    page: categoryPageConfig,
    uri: routeUri,
    mockedImage,
    noHoverAction: true,
    isSwiper: true,
    categoryPageConfig,
    gridConfigs,
    imageType: 'standard',
    className: EditorialPagesStyles,
    avaliableModules: [
      textbar,
      promo50,
      promo50small,
      spacer,
      featuredproduct,
      texteditor,
      hero,
      hero50,
      hero50textimage,
      panorama,
      panorama50,
      tripplepromo,
      tripplepromotext,
      texteditor,
      centraProducts,
      instagram,
      textintro,
      textquote,
    ],
  };

  return (
    <>
      <Block width="fullscreen" theme="light">
        <PageMetaData data={categoryPageConfig} />
        <CJAffiliationTag
          sitePage={{
            pageType: 'category',
          }}
        />
        <StateContainer {...params} />
      </Block>
      {categoryPageConfig && <ContentfulPagesRenderer {...params} />}
      <OnMobileAndTabletOnly>
        <CategoryBreadcrumbs color="white" />
      </OnMobileAndTabletOnly>
    </>
  );
};
